import 'slick-carousel'

export function initialize() {

    // Carousels
// http://kenwheeler.github.io/slick/
// ----------------------------------------------------------------------------

    $('.carousel--default').slick({
        slidesToShow: 4,
        responsive: [
            {
                // breakpoint, in this context means, "up to but not including this number":
                breakpoint: 960,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                // breakpoint, in this context means, "up to but not including this number":
                breakpoint: 480,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    })


    $('.carousel--full-bleed').slick({
        centerMode: true,
        variableWidth: true,
        slidesToShow: 4
    })

    $('.carousel--grid').slick({
        centerMode: true,
        centerPadding: '88px',
        rows: 2,
        slidesPerRow: 4,
        responsive: [
            {
                // breakpoint, in this context means, "up to but not including this number":
                breakpoint: 960,
                settings: {
                    slidesPerRow: 2
                }
            },
            {
                // breakpoint, in this context means, "up to but not including this number":
                breakpoint: 768,
                settings: {
                    centerPadding: '60px',
                    slidesPerRow: 1
                }
            }
        ]
    })

}